module.exports = __webpack_public_path__ + "static/media/european_bell_beaker_icon_medium.65286e5c.png";